export enum IBoosterOfferStatsType {
    Area = "area",
    Garage = "garage",
    Floor = "floor",
    Room = "room",
    Balcony = "balcony",
    Terrace = "terrace",
    QuarterNorth = "quarter_north",
    QuarterSouth = "quarter_south",
    QuarterEast = "quarter_east",
    QuarterWest = "quarter_west"
}
export enum IBoosterOfferStatsType {
    Area = "area",
    Garage = "garage",
    Floor = "floor",
    Room = "room",
    Balcony = "balcony",
    Terrace = "terrace",
    QuarterNorth = "quarter_north",
    QuarterSouth = "quarter_south",
    QuarterEast = "quarter_east",
    QuarterWest = "quarter_west"
}
